import { C as Cart } from './cart-BEbKDMPu.js';
import { P as PubSub } from './pubsub-CoPYzvVm.js';
import { p as parseHTML } from './parseHTML-Om2c1Ayj.js';
import './uniq-BDEfcc0N.js';
import './notyf-DIw0RvBj.js';

class PaypalPaylaterMessaging extends HTMLElement {
  #unsubscribers = [];

  static {
    Cart.sections.push('fetch-cart-paypal-paylater-messaging');
  }

  connectedCallback() {
    this.#unsubscribers.push(
      ...['cart:add', 'cart:update', 'cart:change'].map((event) =>
        PubSub.subscribe(event, ({ sections }) => this.#renderSection(sections))
      )
    );
  }

  disconnectedCallback() {
    this.#unsubscribers.forEach((unsubscribe) => unsubscribe());
  }

  #renderSection(sections) {
    const html = parseHTML(sections['fetch-cart-paypal-paylater-messaging']);
    const target = html.querySelector('paypal-paylater-messaging');
    this.replaceWith(target);
  }
}

customElements.define('paypal-paylater-messaging', PaypalPaylaterMessaging);
